'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function (root, factory) {
    if (typeof module !== 'undefined' && module.exports !== undefined) {
        module.exports = factory();
    } else if (typeof define !== 'undefined' && define.amd) {
        define('IDate', [], function () {
            return factory();
        });
    } else {
        root.IDate = factory();
    }
})(window || module || {}, function () {
    var _reservedDateStrings = {
        today: function today() {
            return new Date(this.currentDate.year, this.currentDate.month - 1, this.currentDate.date, 0, 0, 0, 0);
        },
        tomorrow: function tomorrow() {
            return new Date(this.currentDate.year, this.currentDate.month - 1, this.currentDate.date + 1, 0, 0, 0, 0);
        },
        yesterday: function yesterday() {
            return new Date(this.currentDate.year, this.currentDate.month - 1, this.currentDate.date - 1, 0, 0, 0, 0);
        },
        // 1st of next month
        nextMonth: function nextMonth() {
            return new Date(this.currentDate.year, this.currentDate.month, 1, 0, 0, 0, 0);
        },
        now: function now() {
            return new Date();
        }
    },
        _monthNameMasks = [/янв[а-я]*|с[іi]ч[а-я]*|jan[a-z]*/i, /фев[а-я]*|лют[а-я]*|feb[a-z]*/i, /мар[а-я]*|бер[а-я]*|mar[a-z]*/i,
    /**
     * i - украинская и английская
     */
    /апр[а-я]*|кв[іi][а-я]*|apr[a-z]*/i, /ма[йя]|тра[а-я]*|may[a-z]*/i, /июн[а-я]*|чер[а-я]*|jun[a-z]*/i, /июл[а-я]*|лип[а-я]*|jul[a-z]*/i, /авг[а-я]*|сер[а-я]*|aug[a-z]*/i, /сен[а-я]*|вер[а-я]*|sep[a-z]*/i, /окт[а-я]*|жов[а-я]*|oct[a-z]*/i, /ноя[а-я]*|лис[а-я]*|nov[a-z]*/i, /дек[а-я]*|гру[а-я]*|dec[a-z]*/i],
        _monthNames = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
        _monthNamesShort = ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
        _monthNamesWithDate = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'],
        _dayOfWeekShort = ['empty because first day is 1', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс'],
        _dayOfWeek = ['empty because first day is 1', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье'],
        _dateStringParsers = [{
        // May 31, 2013
        mask: /^([\wа-яїієё]+)\s+(\d{1,2}),\s+(\d{4})/i,
        attributes: function attributes() {
            return {
                lastMatch: RegExp.lastMatch,
                date: +RegExp.$2,
                year: +this._getFullYear(RegExp.$3),
                month: +this._getMonth(RegExp.$1)
            };
        }
    }, {
        // yyyymmdd || yyyymm
        mask: /^((?:19|20)[\d]{2})[.-]?(0[1-9]|1[0-2]|[1-9])[.-]?(0[1-9]|[12][\d]|3[01]|[1-9])?/i,
        attributes: function attributes() {
            return {
                lastMatch: RegExp.lastMatch,
                year: +this._getFullYear(RegExp.$1),
                month: +RegExp.$2,
                date: +RegExp.$3
            };
        }
    }, {
        // dd.mm.yyyy | dd.mm.yy | dd.mm
        mask: /^(0[1-9]|[12][\d]|3[01]|[1-9])[.-](0[1-9]|1[0-2]|[1-9])[.-]?((?:19|20)[\d]{2}|[\d]{2})?(?:$|\s|T)/i,
        attributes: function attributes() {
            return {
                lastMatch: RegExp.lastMatch,
                date: +RegExp.$1,
                month: +RegExp.$2,
                year: +this._getFullYear(RegExp.$3)
            };
        }
    }, {
        /*
         * 28 янв 2010
         * 28 января 2010
         * 28 jan 2010
         * 28 січ 2010
         */
        mask: /^(0[1-9]|[12][\d]|3[01]|[1-9])[\s]+([\wа-яїієё]+)[\s.]+((19|20)[\d]{2}|[\d]{2})/i,
        attributes: function attributes() {
            return {
                lastMatch: RegExp.lastMatch,
                date: +RegExp.$1,
                year: +this._getFullYear(RegExp.$3),
                // ВАЖНО: идет последним потому что перетирает RegExp $
                month: +this._getMonth(RegExp.$2)
            };
        }
    }, {
        /*
         * янв 2010
         * января 2010
         * jan 2010
         * січ 2010
         */
        mask: /^([a-zа-яїієё]+)[\s.]+((19|20)[\d]{2}|[\d]{2})/i,
        attributes: function attributes() {
            return {
                lastMatch: RegExp.lastMatch,
                date: '01',
                year: +this._getFullYear(RegExp.$2),
                // ВАЖНО: идет последним потому что перетирает RegExp $
                month: +this._getMonth(RegExp.$1)
            };
        }
    }],
        _timeStringParsers = [{
        // HH:MM:ss PM
        mask: /(0[\d]|1[\d]|[\d]):(0[\d]|[1-5][\d]|[\d])[:]?(0[\d]|[1-5][\d]|[\d])?\sPM$/i,
        attributes: function attributes() {
            var hours = +RegExp.$1;

            return {
                hours: hours !== 12 ? hours + 12 : hours,
                minutes: +RegExp.$2,
                seconds: +RegExp.$3,
                ms: +RegExp.$4
            };
        }
    }, {
        // HH:MM:ss.mmm || HH:MM:ss || HH:MM
        mask: /(0[\d]|1[\d]|2[0-3]|[\d]):(0[\d]|[1-5][\d]|[\d])[:]?(0[\d]|[1-5][\d]|[\d])?[.]?([\d]{1,3})?/i,
        attributes: function attributes() {
            return {
                hours: +RegExp.$1,
                minutes: +RegExp.$2,
                seconds: +RegExp.$3,
                ms: +RegExp.$4
            };
        }
    }],
        _formats = {
        full: 'dd.mm.yyyy HH:MM',
        timestamp: 'yyyy-mm-ddTHH:MM:ss Z',
        date: 'dd.mm.yyyy',
        time: 'HH:MM'
    },
        _formatAnchors = /(HH|MM|ss|mmm|dd|D|ds|l|mm|fs|F|f|yyyy|yy|Z)/g,
        _formatGetters = {
        'HH': function HH() {
            return this._addZeros(this.attributes.hours, 2);
        },
        'MM': function MM() {
            return this._addZeros(this.attributes.minutes, 2);
        },
        'ss': function ss() {
            return this._addZeros(this.attributes.seconds, 2);
        },
        'mmm': function mmm() {
            return this._addZeros(this.attributes.ms, 3);
        },
        'dd': function dd() {
            return this._addZeros(this.attributes.date, 2);
        },
        'ds': function ds() {
            return this.attributes.date;
        },
        'D': function D() {
            return this._dayOfWeekShort[this.attributes.day];
        },
        'l': function l() {
            return this._dayOfWeek[this.attributes.day];
        },
        'mm': function mm() {
            return this._addZeros(this.attributes.month, 2);
        },
        'F': function F() {
            return this._monthNamesWithDate[this.attributes.month - 1];
        },
        'f': function f() {
            return this._monthNames[this.attributes.month - 1];
        },
        'fs': function fs() {
            return this._monthNamesShort[this.attributes.month - 1];
        },
        'yyyy': function yyyy() {
            return this.attributes.year;
        },
        'yy': function yy() {
            return String(this.attributes.year).substr(2, 2);
        },
        'Z': function Z() {
            var hoursOffset = this.attributes.timezoneOffset / 60,
                pointer = hoursOffset < 0 ? '+' : '-';

            return 'UTC' + pointer + this._addZeros(Math.abs(hoursOffset), 2);
        }
    };

    var IDate = function () {
        function IDate(value) {
            _classCallCheck(this, IDate);

            // set current date
            this._setCurrentDate();
            // native Date object
            this.nativeDate = value !== undefined ? this.parse(value) : new Date();
            this.attributes = this.toJSON(this.nativeDate);

            var proto = Object.getPrototypeOf(this);
            proto._monthNames = proto._monthNames || _monthNames;
            proto._monthNamesShort = proto._monthNamesShort || _monthNamesShort;
            proto._monthNamesWithDate = proto._monthNamesWithDate || _monthNamesWithDate;
            proto._dayOfWeekShort = proto._dayOfWeekShort || _dayOfWeekShort;
            proto._dayOfWeek = proto._dayOfWeek || _dayOfWeek;

            return this;
        }

        _createClass(IDate, [{
            key: 'parse',
            value: function parse(value) {
                var date = void 0;

                if (value instanceof Date) {
                    date = value;
                } else if (typeof value === 'string') {
                    date = this._getDateFromString(value);

                    if (date.toString() === 'Invalid Date') {
                        date = new Date(value);
                    }
                } else if (value instanceof IDate) {
                    date = value.nativeDate;
                } else if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
                    // update current date for truth result
                    this._setCurrentDate(true);
                    date = this._shiftDate(this.currentDate, value);
                } else if (typeof value === 'number') {
                    date = new Date(value);
                } else if (value === null) {
                    date = new Date('Invalid Date');
                }

                return date;
            }

            /**
             * convert date to object || return self attributes
             * @param {object} date Date
             * @return {object} attributes hash
             */

        }, {
            key: 'toJSON',
            value: function toJSON(date) {
                var attributes = void 0,
                    day = void 0;

                if (date && date instanceof Date) {
                    day = date.getDay();

                    attributes = {
                        date: date.getDate(),
                        // month 0-11
                        month: date.getMonth() + 1,
                        year: date.getFullYear(),
                        hours: date.getHours(),
                        minutes: date.getMinutes(),
                        seconds: date.getSeconds(),
                        ms: date.getMilliseconds(),
                        day: day === 0 ? 7 : day,
                        timezoneOffset: date.getTimezoneOffset()
                    };
                }

                return attributes || this.attributes;
            }

            /**
             * @param {boolean} isShort
             * @return {number} month name
             */

        }, {
            key: 'getMonthName',
            value: function getMonthName() {
                var isShort = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                return (isShort ? this._monthNamesShort : this._monthNames)[this.attributes.month - 1];
            }

            /**
             * getter
             * @param {string} key
             * @return {string|Number}
             */

        }, {
            key: 'get',
            value: function get() {
                var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

                return this.attributes[key.toLowerCase()];
            }
        }, {
            key: 'set',
            value: function set(attributes) {
                if (!attributes) {
                    return this;
                }

                this.nativeDate = new Date(attributes.year || this.attributes.year, attributes.month ? attributes.month - 1 : this.attributes.month - 1, attributes.date || attributes.date === 0 ? attributes.date : this.attributes.date, attributes.hours || attributes.hours === 0 ? attributes.hours : this.attributes.hours, attributes.minutes || attributes.minutes === 0 ? attributes.minutes : this.attributes.minutes, attributes.seconds || attributes.seconds === 0 ? attributes.minutes : this.attributes.seconds, attributes.ms || attributes.ms === 0 ? attributes.ms : this.attributes.ms);

                this.attributes = this.toJSON(this.nativeDate);

                return this;
            }

            /**
             * Get full date string
             * @param {String|null} format full || some kind of 'dd.mm.yyyy HH:MM'
             * @return {String}
             */

        }, {
            key: 'toString',
            value: function toString() {
                var _this = this;

                var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _formats.full;

                var string = void 0;

                string = format.replace(_formatAnchors, function (match, anchor, offset, string) {
                    return _formatGetters[anchor] ? _formatGetters[anchor].call(_this) : anchor;
                });

                return string;
            }

            /**
             * Get Date object
             * @return {Date}
             */

        }, {
            key: 'toDate',
            value: function toDate() {
                return this.nativeDate;
            }

            /**
             * Alias to toString(dd.mm.yyyy)
             * @param {string} format
             * @return {String}
             */

        }, {
            key: 'date',
            value: function date() {
                var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _formats.date;

                return this.toString(format);
            }

            /**
             * Alias to toString(HH:MM)
             * @param {string} format
             * @return {String}
             */

        }, {
            key: 'time',
            value: function time() {
                var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _formats.time;

                return this.toString(format);
            }

            /**
             * Get unix timestamp string
             * @return {String}
             */

        }, {
            key: 'timestamp',
            value: function timestamp() {
                return this.toString(_formats.timestamp);
            }
        }, {
            key: 'getTime',
            value: function getTime() {
                return this.nativeDate.getTime();
            }

            /**
             * returns the difference between dates at specified units
             * @param {IDate|*} date IDate || IDate parameters
             * @param {String} units  "years" || "months" || "days" || "hours" || "minutes" || "seconds" || "ms". Default "days"
             * @return {*}
             */

        }, {
            key: 'getUnitDifference',
            value: function getUnitDifference(date) {
                var units = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'days';

                units = units.toLowerCase();
                var diff = void 0;

                if (date) {
                    date = date instanceof IDate ? date : new IDate(date);

                    switch (units) {
                        case 'years':
                            diff = this.attributes.year - date.attributes.year + (this.attributes.month - date.attributes.month + (this.attributes.date - date.attributes.date + (this.attributes.hours - date.attributes.hours + (this.attributes.minutes - date.attributes.minutes + (this.attributes.seconds - date.attributes.seconds + (this.attributes.ms - date.attributes.ms) / 100) / 60) / 60) / 24) / (365 / 12)) / 12;
                            break;
                        case 'months':
                            diff = (this.attributes.year - date.attributes.year) * 12 + this.attributes.month - date.attributes.month + (this.attributes.date - date.attributes.date + (this.attributes.hours - date.attributes.hours + (this.attributes.minutes - date.attributes.minutes + (this.attributes.seconds - date.attributes.seconds + (this.attributes.ms - date.attributes.ms) / 100) / 60) / 60) / 24) / (365 / 12);
                            break;
                        case 'hours':
                            diff = (this.getTime() - date.getTime()) / (60 * 60 * 1000);
                            break;
                        case 'minutes':
                            diff = (this.getTime() - date.getTime()) / (60 * 1000);
                            break;
                        case 'seconds':
                            diff = (this.getTime() - date.getTime()) / 1000;
                            break;
                        case 'ms':
                            diff = this.getTime() - date.getTime();
                            break;
                        case 'days':
                            diff = (this.getTime() - date.getTime()) / (60 * 60 * 24 * 1000);
                            break;
                    }
                }

                return diff;
            }

            /**
             * Get days count at month
             * @param {Number} [month] 1-12. default this.get('month')
             * @return {Number}
             */

        }, {
            key: 'getDaysInMonth',
            value: function getDaysInMonth(month) {
                month = !isNaN(month) ? month : this.attributes.month;
                // создадим дату следующего месяца и отнимем от нее 1 день (0)
                return new Date(this.attributes.year, month, 0).getDate();
            }

            /**
             * Shifts IDate for months, days..
             * @param {Object} shiftedAttributes  {years, months, days, hours, minutes, seconds, ms} || days
             * @return {IDate}
             */

        }, {
            key: 'getShifted',
            value: function getShifted(shiftedAttributes) {
                var date = void 0;

                if (typeof shiftedAttributes === 'number') {
                    shiftedAttributes = {
                        days: shiftedAttributes
                    };
                }

                date = this._shiftDate(this.attributes, shiftedAttributes);
                return new IDate(date);
            }

            /**
             * получить получить сдвиг на первое число следующего месяца
             * @return {*|IDate|IPeriod}
             */

        }, {
            key: 'nextMonth',
            value: function nextMonth() {
                var currDays = this.getDaysInMonth();

                return new IDate(this).set({ date: 1 }).getShifted(currDays);
            }

            /**
             * получить получить сдвиг на первое число предыдущего месяца
             * @return {*|IDate|IPeriod}
             */

        }, {
            key: 'prevMonth',
            value: function prevMonth() {
                return new IDate(this).set({ date: 1 }).getShifted({ days: -1 }).set({ date: 1 });
            }

            /**
             * Get day of the week (1..7)
             * @return {Number}
             */

        }, {
            key: 'getDayOfWeek',
            value: function getDayOfWeek() {
                return this.attributes.day;
            }

            /**
             *  if one of attributes is NaN
             *  IDate is invalid
             *  @return {boolean}
             */

        }, {
            key: 'validate',
            value: function validate() {
                return !isNaN(this.attributes.year);
            }

            /**
             * Date is equal to
             * @param {IDate|*} date  IDate || IDate parameters
             * @param {null|String} format  null || some kind of 'dd.mm.yyyy HH:MM'
             * @return {Boolean}
             */

        }, {
            key: 'is',
            value: function is(date) {
                var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _formats.date;

                var result = false,
                    isValid;

                date = date instanceof IDate ? date : new IDate(date);

                isValid = date.validate();

                if (isValid) {
                    result = this.toString(format) === date.toString(format);
                }

                return result;
            }
        }, {
            key: '_getFullYear',
            value: function _getFullYear() {
                var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

                var year = void 0;

                if (value && value.length === 4) {
                    year = value;
                } else if (value.length === 2) {
                    // fix it in 2069
                    year = +value >= 70 ? '19' : '20';
                    year += value;
                } else {
                    year = this.currentDate.year;
                }

                return year;
            }

            /**
             * parse dateString
             * @param {String} string
             * @return {Date} date Date
             */

        }, {
            key: '_getDateFromString',
            value: function _getDateFromString() {
                var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

                string = String(string).trim();

                var date = void 0,
                    i = 0,
                    len = void 0,
                    dateAttributes = {},
                    timeAttributes = {};

                if (string && _reservedDateStrings[string]) {
                    date = _reservedDateStrings[string].call(this);
                } else {
                    len = _dateStringParsers.length;

                    for (i; i < len; i++) {
                        if (_dateStringParsers[i].mask.test(string)) {
                            dateAttributes = _dateStringParsers[i].attributes.call(this);
                            break;
                        }
                    }
                    string = string.replace(dateAttributes.lastMatch, '').trim();

                    i = 0;
                    len = _timeStringParsers.length;
                    for (i; i < len; i++) {
                        if (_timeStringParsers[i].mask.test(string)) {
                            timeAttributes = _timeStringParsers[i].attributes.call(this);
                            break;
                        }
                    }

                    date = new Date(dateAttributes.year,
                    // traditional months index 1-12 returns from parser
                    dateAttributes.month - 1,
                    // because 0 its previous day
                    dateAttributes.date || 1,
                    // undefined values makes invalid Date
                    timeAttributes.hours || 0, timeAttributes.minutes || 0, timeAttributes.seconds || 0, timeAttributes.ms || 0);
                }

                return date;
            }
        }, {
            key: '_getMonth',
            value: function _getMonth(value) {
                var i = 0,
                    len = 12,
                    month = void 0;

                for (i; i < len; i++) {
                    if (_monthNameMasks[i].test(value)) {
                        month = i + 1;
                        break;
                    }
                }

                return month;
            }
        }, {
            key: '_shiftDate',
            value: function _shiftDate() {
                var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.attributes;
                var shifted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                return new Date(date.year + (shifted.year || shifted.years || 0), date.month - 1 + (shifted.month || shifted.months || 0), date.date + (shifted.days || shifted.day || 0), date.hours + (shifted.hours || shifted.hour || 0), date.minutes + (shifted.minutes || shifted.minute || 0), date.seconds + (shifted.seconds || shifted.second || 0), date.ms + (shifted.ms || 0));
            }

            /**
             * String like '00023'
             * @param {String} num
             * @param {Number} length  length of string vs zeros
             * @return {String}
             * @private
             */

        }, {
            key: '_addZeros',
            value: function _addZeros() {
                var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                var length = arguments[1];

                var ret = String(num);

                while (ret.length < length) {
                    ret = '0' + ret;
                }

                return ret;
            }

            /**
             * sets current date and update it every minute
             * @param {Boolean} force - update immediately
             * @return {Object}
             */

        }, {
            key: '_setCurrentDate',
            value: function _setCurrentDate() {
                var _this2 = this;

                var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                var proto = Object.getPrototypeOf(this);

                if (!proto.currentDate || !proto.dateUpdateTimer || !force) {
                    proto.currentDate = this.toJSON(new Date());

                    if (force) {
                        clearTimeout(proto.dateUpdateTimer);
                    }

                    proto.dateUpdateTimer = setTimeout(function () {
                        proto.dateUpdateTimer = null;
                        _this2._setCurrentDate();
                    }, 60000);
                }

                return this;
            }

            /**
             * get Html
             * @return {string}
             */

        }, {
            key: 'toHtml',
            value: function toHtml() {
                console.warn('IDate.prototype.toHtml() is deprecated. Use .toString() wrapped by your own HTML tags.');
                return '<span>' + this.toString.apply(this, arguments) + '</span>';
            }

            /**
             * Get date in milliseconds, since 1 january 1970
             * @return {Number}
             */

        }, {
            key: 'getMilliseconds',
            value: function getMilliseconds() {
                console.warn('IDate.prototype.getMilliseconds() is deprecated. Use .getTime().');
                return this.getTime();
            }

            /**
             * Return the difference between dates
             * @param {IDate|*} date  IDate || IDate parameters
             * @return {Object} {years, months, days, hours, minutes, seconds, ms}
             */

        }, {
            key: 'getDifference',
            value: function getDifference(date) {
                console.warn('IDate prototype.getDifference() is deprecated. Use .getUnitDifference().');
                var diff = void 0;

                if (date) {
                    date = date instanceof IDate ? date : new IDate(date);

                    diff = {
                        years: this.attributes.year - date.attributes.year,
                        months: this.attributes.month - date.attributes.month,
                        days: this.attributes.date - date.attributes.date,
                        hours: this.attributes.hours - date.attributes.hours,
                        minutes: this.attributes.minutes - date.attributes.minutes,
                        seconds: this.attributes.seconds - date.attributes.seconds,
                        ms: this.attributes.ms - date.attributes.ms
                    };
                }

                return diff;
            }
        }]);

        return IDate;
    }();

    return IDate;
});